import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

const line = {
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration: 1.1, ease: EASE } },
};

export const MaskHeading = ({ lines, className, testId, as = "h2", onLoad = false, delay = 0 }) => {
  const M = motion[as];
  const trigger = onLoad
    ? { animate: "show" }
    : { whileInView: "show", viewport: { once: true, amount: 0.15 } };
  return (
    <M
      className={className}
      initial="hidden"
      {...trigger}
      variants={{ show: { transition: { staggerChildren: 0.13, delayChildren: delay } } }}
      data-testid={testId}
    >
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span className="block" variants={line}>
            {l}
          </motion.span>
        </span>
      ))}
    </M>
  );
};

export const Eyebrow = ({ children, light = false, testId }) => (
  <p
    data-testid={testId}
    className={`flex items-center gap-3 font-sans text-[11px] sm:text-xs font-bold uppercase tracking-[0.28em] ${
      light ? "text-ns-gold" : "text-ns-bronze"
    }`}
  >
    <span className={`h-px w-8 ${light ? "bg-ns-gold" : "bg-ns-bronze"}`} />
    {children}
  </p>
);

export const Gold = ({ children }) => (
  <em className="font-serif italic font-medium text-ns-goldtext">{children}</em>
);
